import ApplicationSerializer from 'lumen/serializers/application';

export default class MarketingSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'marketing_recommendations') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('marketing/recommendation');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
